import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  messageIcon: {
    color: theme.palette.primary.main,
    background: 'rgba(0, 117, 202, 0.08)',
    marginBottom: '8px',
    marginTop: '2rem',
    [theme.breakpoints.only('xs')]: {
      marginTop: '0',
    },
  },
  actionButton: {
    margin: '1.5rem auto 2rem',
    [theme.breakpoints.only('xs')]: {
      margin: '20px 10px',
    },
  },
  heading: {
    color: '#000',
  },
  baseText: {
    color: '#000',
    fontWeight: 'bold',
    maxWidth: '720px',
  },
  mobileHiddenButton: {
    [theme.breakpoints.only('xs')]: {
      display: 'none',
    },
  },
  mobileBottomButtons: {
    [theme.breakpoints.only('xs')]: {
      position: 'absolute',
      bottom: '0',
      left: '0',
      right: '0',
    },
  },
}))

export default useStyles
